import { render, staticRenderFns } from "./PrintBrackets.vue?vue&type=template&id=2bc6cf67&scoped=true&"
import script from "./PrintBrackets.vue?vue&type=script&lang=js&"
export * from "./PrintBrackets.vue?vue&type=script&lang=js&"
import style0 from "./PrintBrackets.vue?vue&type=style&index=0&id=2bc6cf67&lang=scss&scoped=true&"
import style1 from "./PrintBrackets.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6cf67",
  null
  
)

export default component.exports